import React from 'react';
import { ApButtonText } from '@alixpartners/ui-components';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';

import { getTableData } from './TopJobRoles.helpers';
import { Pagination, TableWrapper } from '../Table.styles';
import { TableHeader, TableHeaderGroup } from '../TableComponents';
import { ICurrencyFormat, ITableRow } from 'utils/types';
import { Container } from './TopJobRoles.styles';
import isEqual from 'lodash/isEqual';
import { HEADER_HEIGHT, ROW_HEIGHT } from '../table-utils';
import { GridReadyEvent } from 'ag-grid-community';

interface ITopJobRolesProps {
  columnDateLabels: string[];
  format: ICurrencyFormat;
  isHeadcount: boolean;
  permanentContractorChecked?: boolean;
  pageSize?: number;
  totalRow?: ITableRow;
  rowData: Array<ITableRow>;
}

interface ITopJobRolesState {
  columnDefs: any[];
  extraRows: number;
  gridApi: any;
}
export class TopJobRoles extends React.Component<
  ITopJobRolesProps,
  ITopJobRolesState
> {
  state = {
    columnDefs: [],
    extraRows: 0,
    gridApi: null,
  };

  setExtraRows = (extraRows: number) => {
    this.setState({ extraRows });
  };

  onGridReady = (event: GridReadyEvent) => {
    const { pageSize } = this.props;
    const { extraRows } = this.state;
    const paginationPageSize = (pageSize || 10) * (extraRows + 1);
    this.setState({
      gridApi: event.api,
    });
    event.api.paginationSetPageSize(paginationPageSize);
  };

  componentDidMount() {
    const {
      columnDateLabels,
      format,
      isHeadcount,
      permanentContractorChecked,
    } = this.props;
    const { columnDefs } = getTableData({
      columnDateLabels,
      format,
      isHeadcount,
      permanentContractorChecked,
    });
    this.setState({ columnDefs: [] }, () => {
      this.setState({ columnDefs });
    });
  }

  componentDidUpdate(prevProps: ITopJobRolesProps) {
    const {
      columnDateLabels,
      format,
      isHeadcount,
      permanentContractorChecked,
    } = this.props;
    if (
      !isEqual(prevProps.columnDateLabels, columnDateLabels) ||
      !isEqual(prevProps.format, format) ||
      !isEqual(prevProps.isHeadcount, isHeadcount) ||
      !isEqual(prevProps.permanentContractorChecked, permanentContractorChecked)
    ) {
      const { columnDefs } = getTableData({
        columnDateLabels,
        format,
        isHeadcount,
        permanentContractorChecked,
      });
      this.setState({ columnDefs: [] }, () => {
        this.setState({ columnDefs });
      });
    }
  }

  render() {
    const { pageSize = 10, rowData, totalRow } = this.props;
    const { columnDefs, extraRows } = this.state;
    const paginationPageSize = pageSize * (extraRows + 1);
    const gridOptions = {
      columnDefs,
      defaultColDef: { width: 54, sortable: true },
      rowData,
      rowHeight: ROW_HEIGHT,
      headerHeight: HEADER_HEIGHT,
    };

    return (
      <Container>
        <TableWrapper className="ag-theme-balham">
          <AgGridReact
            {...gridOptions}
            frameworkComponents={{
              customHeaderGroupComponent: TableHeaderGroup,
              agColumnHeader: TableHeader,
            }}
            onGridReady={this.onGridReady}
            pinnedTopRowData={[totalRow]}
            suppressCopyRowsToClipboard
            suppressScrollOnNewData
            suppressRowHoverHighlight
            suppressRowDrag
            suppressRowClickSelection
            suppressCellSelection
            suppressCsvExport
            suppressExcelExport
            suppressContextMenu
            domLayout="autoHeight"
            paginationPageSize={paginationPageSize}
            paginationAutoPageSize={true}
            pagination={true}
            suppressPaginationPanel={true}
          />
        </TableWrapper>
        <Pagination>
          {paginationPageSize}/{rowData.length}
          {paginationPageSize !== rowData.length && (
            <ApButtonText
              onClick={() => {
                const { gridApi } = this.state;
                // @ts-ignore
                const currentPageSize = gridApi.paginationGetPageSize();
                // @ts-ignore
                gridApi.paginationSetPageSize(currentPageSize + pageSize);
                this.setExtraRows(extraRows + 1);
              }}
            >
              SHOW MORE...
            </ApButtonText>
          )}
        </Pagination>
      </Container>
    );
  }
}

export default TopJobRoles;
